<div class="row row_main" style="margin-bottom: 10%;">

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
    <h1 class="titulo-simpli">Dashboard</h1>
    <small class="subtitulo-simpli">Revisa como se comportan las compras de tu empresa mes a mes. </small>

    </div>
    

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">

      <div class="row">

        <div class="col-lg-8 col-md-8 col-sm-8 col-xs-12" style="margin:0 auto;margin-top: 20px;">

          <div class="container-box">

            <div class="neumorphism2 excelbox" routerLink="/home/dashboard">
              <span class="material-symbols-outlined excelicon">trending_up</span>
              <br>
              <small>Dashboard ventas</small>
            </div>
    
            <div class="neumorphism2 excelbox" style="pointer-events: none;background: var(--simpli-primary);">
              <span class="material-symbols-outlined excelicon" style="color: var(--simpli-secondary);">filter_alt</span>
              <br>
              <small style="color: var(--simpli-secondary);">Dashboard compras</small>
            </div>
    
            <div class="neumorphism2 excelbox" (click)="dash_update()"  id="disable_compras">
              <span class="material-symbols-outlined excelicon">sync</span>
              <br>
              <small>Sincronizar información</small>
            </div>
    
            <div class="neumorphism2 excelbox" (click)="dicom()">
              <span class="material-symbols-outlined excelicon">arrow_downward</span>
              <br>
              <small>Consulta Dicom</small>
            </div>
    
          </div>

        </div>

      </div>




    </div>

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top">
      <form [formGroup]="formFechas" style="margin-top: 29px;" >
        <div class="row row_main" style="padding-left: 0;">
          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-top">
            <mat-form-field>
              <mat-label>Desde</mat-label>
              <input matInput formControlName="fechaI"  [matDatepicker]="picker" (dateChange)="fecha_desde($event)" style="text-decoration: none !important;">
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
  
          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-top">
            <mat-form-field>
              <mat-label>Hasta</mat-label>
              <input matInput formControlName="fechaF"  [matDatepicker]="picker1" (dateChange)="fecha_hasta($event)" style="text-decoration: none !important;">
              <mat-datepicker-toggle matSuffix [for]="picker1"></mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>          
          </div>

          <div class="col-lg-3 col-md-3 col-sm-12 col-xs-12 col-top">
            <button [disabled]="d_btn" mat-flat-button style="margin-top: 20px;" class="secondary-button" (click)="clear()" type="button">Restablecer Fechas</button>       
          </div>
  
        </div>
      </form>

    </div>
      

    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">


        <div class="row">

            <div  class="col-lg-12 col-md-12 col-sm-12 col-xs-12 col-top animate__animated animate__fadeIn">
                <app-concentracion-factoring [company_id]="company_id" [date_end]="date_end" [date_start]="date_start"></app-concentracion-factoring>
            </div>

        </div>

    </div>


</div>